import { createClient } from '@supabase/supabase-js'

// Public, client-safe values. The Supabase "anon"/"publishable" key is designed to be
// shipped in frontend bundles: real protection comes from Row Level Security (RLS)
// policies configured on every table (see docs/supabase.md), never from hiding this key.
// Never put the service_role/secret key here or anywhere in frontend code.
const SUPABASE_URL = 'https://lhvtxhluswtdmwilrcwa.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_2pU3AOs8sCQVDSwxqkiNtg_xblyIt7D'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
      persistSession: true,
          autoRefreshToken: true,
              detectSessionInUrl: true,
                  storageKey: 'dze-journal-auth',
                    },
                    })

                    /** Private bucket for trade screenshots. See docs/supabase.md. */
                    export const SCREENSHOTS_BUCKET = 'trade-screenshots'

                    /** How long a signed URL used to display a screenshot stays valid, in seconds. */
                    export const SIGNED_URL_TTL = 60 * 60